import VideoMask from './VideoMask';
import './HeroContent.css';

/**
 * Keeps the existing headline and copy verbatim. The 3D comes from useScroll3D
 * (mounted once in MasterPage) reading the data-depth / data-tilt attributes.
 */
export default function HeroContent({ onSeeApps }) {
  return (
    <section className="rw-hero">
      <div className="rw-hero__rules" data-depth="1.5" data-fade="1" aria-hidden="true">
        <i /><i /><i /><i /><i />
      </div>

      <div className="rw-hero__word" data-depth="1.05" data-flat="-150" aria-hidden="true">RIFTWORKS</div>

      <div className="rw-hero__inner">
        <div className="rw-hero__copy" data-depth="0.16">
          <div className="rw-hero__eyebrow">
            <span className="rw-hero__dash" />
            <span className="rw-kicker">SaaS solutions &middot; Agentic AI</span>
          </div>
          <h1 className="rw-hero__title">Endless Possibilities</h1>
          <p className="rw-hero__lede">
            There is always a new way to perform the daily IT tasks.
            Our solutions mixed with coding and AI creates easier ways.
          </p>
          <div className="rw-hero__actions">
            <a href="#rw-what" className="rw-btn rw-btn--primary">Learn How</a>
            <button type="button" className="rw-btn rw-btn--secondary" onClick={onSeeApps}>
              Our applications
            </button>
          </div>
        </div>

        <div className="rw-hero__media" data-depth="0.55" data-tilt="1">
          <VideoMask className="rw-vm--framed" ratio="16 / 9" />
        </div>
      </div>

      <div className="rw-hero__cue">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="4" x2="12" y2="20" />
          <polyline points="6 14 12 20 18 14" />
        </svg>
        Scroll
      </div>
    </section>
  );
}
